<section [ngStyle]="carouselWrapperStyle()" class="carousel-wrapper" data-testid="carousel-wrapper">
  <ul #carousel class="carousel-inner" data-testid="carousel-inner">
    @for (item of items(); track item) {
      <li #carouselItem class="carousel-item" data-testid="carousel-item">
        <ng-container [ngTemplateOutlet]="item.tpl" />
      </li>
    }
  </ul>
  @if (showControls()) {
    <div
      class="width-match-parent"
      fxLayoutAlign="center start"
      fxLayoutGap="16px"
      data-testid="carousel-controls"
    >
      <button
        (click)="prev()"
        [attr.aria-label]="'COMMON.previous' | translate"
        [disabled]="isFirstSlide()"
        color="primary"
        mat-icon-button
        data-testid="carousel-prev-button"
      >
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
      </button>
      <button
        (click)="next()"
        [attr.aria-label]="'COMMON.next' | translate"
        [disabled]="isLastSlide()"
        color="primary"
        mat-icon-button
        data-testid="carousel-next-button"
      >
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </button>
    </div>
  }
</section>
